
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.125 24h14.25V3.75H16.5V3h-5.25V0h-6v3H0v.75h1.125V24zM6 .75h4.5V3H6V.75zm8.625 3v19.5H1.875V3.75h12.75z"}}),_c('path',{attrs:{"d":"M5.625 7.5h1v12.75h-1zm4.5 0h1v12.75h-1z"}})])
          )
        }
      }
    